"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = (0, styled_components_1.default)(ui_1.BaseButton) `
  box-sizing: border-box;
  padding: 10px;

  color: ${({ theme }) => theme.textSecondary};
  font-size: 11px;
  line-height: 18px;

  white-space: normal;
  text-align: left;
  word-wrap: break-word;
  opacity: ${({ $isRestorable }) => ($isRestorable ? 1 : 0.5)};
`;
